import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, cloneElement } from "react";
import "@volue/stitches-core";
import { useSlotProps, ClearSlots } from "../../utils/slots.es.js";
import stitches from "../theme.config.es.js";
import { domProps } from "../../utils/domProps.es.js";
import { mergeProps } from "../../utils/mergeProps.es.js";
const headingCss = stitches.css({
  fontFamily: "$headerFont",
  color: "$heading-text",
  margin: 0,
  variants: {
    size: {
      "1": {
        fontSize: "$h1",
        fontWeight: "$h1",
        lineHeight: "$h1"
      },
      "2": {
        fontSize: "$h2",
        fontWeight: "$h2",
        lineHeight: "$h2"
      },
      "3": {
        fontSize: "$h3",
        fontWeight: "$h3",
        lineHeight: "$h3"
      },
      "4": {
        fontSize: "$h4",
        fontWeight: "$h4",
        lineHeight: "$h4"
      },
      "5": {
        fontSize: "$h5",
        fontWeight: "$h5",
        lineHeight: "$h5"
      },
      "6": {
        fontSize: "$h6",
        fontWeight: "$h6",
        lineHeight: "$h6"
      }
    },
    casing: {
      uppercase: { textTransform: "uppercase" }
    },
    color: {
      green: { color: "$heading-green" },
      blue: { color: "$heading-blue" }
    }
  }
});
const subheadingCss = stitches.css({
  color: "$subheading-text",
  fontSize: "$subheading",
  fontWeight: "$subheading",
  lineHeight: "$subheading",
  marginTop: "$100"
});
const alignCss = stitches.css({
  variants: {
    align: {
      center: { display: "block", textAlign: "center" },
      left: { display: "block", textAlign: "left" },
      right: { display: "block", textAlign: "right" }
    }
  }
});
const EzHeading = forwardRef(
  ({
    align,
    as,
    casing,
    children: title,
    color,
    size,
    subheading: subtitle,
    truncateHeading,
    ...additionalProps
  }, ref) => {
    var _a;
    const HeadingLevel = as || `h${size}`;
    const slotProps = useSlotProps({}, "heading");
    const headingElement = /* @__PURE__ */ jsx(
      HeadingLevel,
      {
        className: headingCss({ size, casing, color }),
        title: truncateHeading ? title : void 0,
        children: /* @__PURE__ */ jsx(ClearSlots, { children: title })
      }
    );
    const subheadingElement = subtitle && (size === "3" || size === "5") && /* @__PURE__ */ jsx("div", { className: subheadingCss(), title: truncateHeading ? subtitle : void 0, children: /* @__PURE__ */ jsx(ClearSlots, { children: subtitle }) });
    const wrapperElement = /* @__PURE__ */ jsxs("div", { children: [
      headingElement,
      subheadingElement
    ] });
    const el = subheadingElement ? wrapperElement : headingElement;
    const props = domProps(slotProps, alignCss({ align }));
    return cloneElement(
      el,
      mergeProps(
        props,
        additionalProps,
        { ref, className: EzHeading["__internalComponentSelector"] },
        { className: (_a = el.props.className) == null ? void 0 : _a.toString() }
      )
    );
  }
);
EzHeading["__internalComponentSelector"] = "css-ezh";
EzHeading.displayName = "EzHeading";
export {
  EzHeading as default
};
//# sourceMappingURL=EzHeading.es.js.map
